import { ReachabilityTestResult } from "modules/systemCheck/components/types";
import { Box } from "@remo-co/ui-core/src/components/Box";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useI18n } from "i18n";
import {
  REACHABILITY_TESTS_MESSAGES,
  ReachabilityTest,
} from "modules/systemCheck/components/constants";
import { SUPPORT_STATUS } from "modules/systemCheck/constants";
import { StatusIcon } from "modules/systemCheck/components/StatusIcon";

interface Props {
  reachabilityResult: ReachabilityTestResult;
}

export const ReachabilityDetection = ({
  reachabilityResult,
}: Props): JSX.Element | null => {
  const { t } = useI18n(["micCamCheck"]);

  const failedTests = Object.entries(reachabilityResult).filter(
    ([, result]) => !result.isSuccessful,
  );

  if (failedTests.length === 0) {
    return null;
  }

  return (
    <Box display="flex" flexWrap="wrap" data-testid="reachability-detection">
      <Typography variant="subtitle1" style={{ whiteSpace: "pre-line" }}>
        {t("micCamCheck:network.is.blocking.site")}
      </Typography>
      {failedTests.map(([reachabilityTest, result]) => (
        <Box
          key={reachabilityTest}
          display="flex"
          alignItems="center"
          flexWrap="wrap"
          marginTop={2}
          sx={{ width: "fit-content", minWidth: "50%" }}
        >
          <StatusIcon
            status={
              result.isSuccessful
                ? SUPPORT_STATUS.SUPPORTED
                : SUPPORT_STATUS.UNSUPPORTED
            }
          />
          <Typography
            variant="subtitle1"
            className={result.isSuccessful ? "success" : "error"}
          >
            {t(
              REACHABILITY_TESTS_MESSAGES[reachabilityTest as ReachabilityTest],
            )}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
